import React from 'react';
import Translator from '../../../core/i18n';
import { Log } from 'ng2-logger';
import { ICourseContentWeekActivities } from '../../../models/components/course-content-weekactivities';
import { IAppState, IAction } from '../../../models/action/core';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../store/actions/coursePage';
import { Common } from '../../../core/common';
import { GetActivitiesType } from '../../../models/enums/GetActivityType';
import { string } from 'prop-types';
import { CourseContentMenuType } from '../../../models/enums/CourseContentMenuType';
import Moment from 'moment';
import ReactGA from 'react-ga4';
import { UserType } from '../../../models/enums/userType';

const T = Translator.create();
const _logger = Log.create('course-content-week-activities');
const token: any = localStorage.getItem('access_token');
let _common: Common;
let scrollListenner: any;
let selecTedScroll: string;

class CourseContentWeeksActivities extends React.Component<ICourseContentWeekActivities> {
    public state = {
        showMoreCount: 5,
        showMoreStartedCount: 5,
        actviteActivityId: '',
        activeWeekId: '',
        redirect: false,
        selectedActivityId: '',
        scrollActivityId: '',
        enableScroll: true,
        activityOnClicked: false,
        redirectUrl: ''
    };
    constructor(props: any) {
        super(props);
        _common = new Common();
        this.activityOnClickProcessing = this.activityOnClickProcessing.bind(this);
    }

    public componentDidMount = () => {
        this.activityOnClickProcessing(this.props);
        this.addAndRemoveActiveClass(this.props);
        scrollListenner = document.getElementById("activities-tab");
        this.props.dispatch(Actions.setPassiveButton(false))

        scrollListenner!.addEventListener("scroll", this.trackScrolling);
    };

    public componentWillUnmount = () => {
        const itemPosition = document.getElementById('activity-card-' + selecTedScroll);
        const getScrollElement = document.getElementById('activities-tab');

        let mobileBlank = 35;
        if(this.props.showMobile)
        {
            mobileBlank = 100;
        }

        if (itemPosition && getScrollElement && itemPosition.offsetTop) {
            getScrollElement.scrollTop = itemPosition.offsetTop - mobileBlank;
        }

       // document.getElementById('activities-tab')!.removeEventListener('scroll', this.trackScrolling);
    }

    scrollSelectedActivity = () => {
        const itemPosition = document.getElementById('activity-card-' + this.state.selectedActivityId);
        const getScrollElement = document.getElementById('activities-tab');
        if (itemPosition && getScrollElement) {
            getScrollElement.scrollTop = itemPosition.offsetTop - 5;
            const parsedUrl = new URL(window.location.href);
            let type = '';
            if (parsedUrl.search.includes('type=1')) {
                let typePart = parsedUrl.search.split('&type=')[1]
                type = typePart.split('&actid')[0]
            }
        }
    }

    handleNavigation = (redirectUrl: string) => {
        const currentPath = window.location.pathname;
        const currentSearch = window.location.search;
        const currentParams = new URLSearchParams(currentSearch);
        
        const targetUrlObj = new URL(redirectUrl, window.location.origin);
        const targetParams = new URLSearchParams(targetUrlObj.search);
        
        const classIdMatch = currentParams.get('classId') === targetParams.get('classId');
        const activityIdMatch = currentParams.get('activityId') === targetParams.get('activityId');
        const typeMatch = currentParams.get('type') === targetParams.get('type');
        const actidMatch = currentParams.get('actid') === targetParams.get('actid');
        const weekorunitidMatch = currentParams.get('weekorunitid') === targetParams.get('weekorunitid');
        
        if (currentPath !== '/almsp/u/course' || !classIdMatch || !activityIdMatch || !typeMatch || !actidMatch || !weekorunitidMatch) {
            window.history.pushState({}, '', redirectUrl);
            window.dispatchEvent(new Event('popstate'));
        }
    }

    public componentDidUpdate = (prevProps: ICourseContentWeekActivities, prevState: any) => {
        if (this.props.courseContentActivityCardRefresh !== prevProps.courseContentActivityCardRefresh || this.props.activityCard !== prevProps.activityCard) {
            if (this.props.courseContentMenuType === CourseContentMenuType.weekAndActivityStory) {
                if (this.state.selectedActivityId) {
                    this.scrollSelectedActivity();
                }
            }
        }
        
        if(this.props.resetShowMoreCount){
            this.setState((prevState: any) =>({
                showMoreCount: prevState.showMoreStartedCount
            }))
            this.props.dispatch(Actions.SetResetShowMoreCount(false))
        }

        if (this.state.redirect && !prevState.redirect && this.state.redirectUrl) {
            this.handleNavigation(this.state.redirectUrl);
            this.setState({
                redirect: false
            });
        }
    }

    weekScroll = (item: any) => {
        
        if (item) {
            const getScrollElement = document.getElementById('profileMainLoading_Content');
            const getAllActiveClass = document.getElementsByClassName('courseContentWeekActivityActive');

            for (let index = 0; index < getAllActiveClass.length; index++) {
                getAllActiveClass[index].classList.remove('courseContentWeekActivityActive');
            }


            let getActivityMenuItemElement = document.getElementById(item.id);
            if (getActivityMenuItemElement) {
                getActivityMenuItemElement.classList.add('courseContentWeekActivityActive');
            }

            const getActivityId = item.dataset.activityid.toString();
            const getWeek = item.dataset.weekid.toString();
            const targetUrl = '/almsp/u/course?classId=' + this.props.coursePageClassId + '&activityId=' + this.props.coursePageActivityId + '&type=1' + '&actid=' + getActivityId + '&weekorunitid=' + getWeek;
            this.setState({
                ...this.state,
                actviteActivityId: getActivityId,
                activeWeekId: getWeek,
                redirect: true,
                redirectUrl: targetUrl
            });

            if (getScrollElement && item.id != '') {
                getScrollElement.scrollTop = item.offsetTop - 5;
            }
        }
    }

    trackScrolling = () => {

        const els = document.getElementsByClassName('activity-card-scroll');
        const arrayActivities = [];
        for (let i = 0; i < els.length; i++) {
            arrayActivities.push({ top: els[i].getBoundingClientRect().top, Id: els[i].id.replace('activity-card-', '') });
        }
        if (arrayActivities.length > 0) {
            const currentDivElement = arrayActivities.filter(f => f.top > 0).sort((a, b) => a.top - b.top)[0];
            if (currentDivElement && (this.state.scrollActivityId === '' || this.state.scrollActivityId !== currentDivElement.Id)) {
                this.setState({
                    ...this.state,
                    enableScroll: true,
                    scrollActivityId: currentDivElement.Id
                });
                let itemPostisiton = document.getElementById('week_activity_' + currentDivElement.Id);
                if (currentDivElement.Id && !this.state.activityOnClicked) {
                    this.weekScroll(itemPostisiton);
                }
            }
            if (currentDivElement && arrayActivities[this.state.showMoreCount - 1] && arrayActivities[this.state.showMoreCount - 1].Id && (arrayActivities[this.state.showMoreCount - 1].Id === currentDivElement.Id)) {
                this.setState({
                    ...this.state,
                    showMoreCount: this.state.showMoreCount + 5
                });
            }
        }
        scrollListenner!.removeEventListener("scroll", this.trackScrolling);
        scrollListenner!.addEventListener("scroll", this.trackScrolling);
    };

    public activityOnClick = (event: React.MouseEvent<HTMLDivElement>) => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_ACTIVITY_CLICKED',
            label:'G_ACTIVITY_CLICKED',
            nonInteraction: true,
          });
        
          this.props.closeModal();

        const getAllActiveClass = document.getElementsByClassName('courseContentWeekActivityActive');
        if (event) {
            if (event.currentTarget.classList.contains('courseContentWeekActivityActive')) {
                event.currentTarget.classList.remove('courseContentWeekActivityActive');
            } else {
                for (let index = 0; index < getAllActiveClass.length; index++) {
                    getAllActiveClass[index].classList.remove('courseContentWeekActivityActive');
                }
                event.currentTarget.classList.add('courseContentWeekActivityActive');
            }
            if (event.currentTarget.dataset.activityid && event.currentTarget.dataset.weekid) {
                const getActivityId = event.currentTarget.dataset.activityid.toString();
                const getWeek = event.currentTarget.dataset.weekid.toString();
                const targetUrl = '/almsp/u/course?classId=' + this.props.coursePageClassId + '&activityId=' + this.props.coursePageActivityId + '&type=1' + '&actid=' + getActivityId + '&weekorunitid=' + getWeek;
                this.setState({
                    ...this.state,
                    actviteActivityId: getActivityId,
                    activeWeekId: getWeek,
                    redirect: true,
                    redirectUrl: targetUrl
                });

                if (getActivityId && this.state.selectedActivityId !== getActivityId && this.props.courseContentMenuType === CourseContentMenuType.weekAndActivityStory) {
                    this.setState({
                        ...this.state,
                        enableScroll: false,
                        selectedActivityId: getActivityId,
                        activityOnClicked: true
                    });
                    selecTedScroll = getActivityId;
                    const itemPosition = document.getElementById('activity-card-' + getActivityId);
                    const getScrollElement = document.getElementById('activities-tab');

                    if (itemPosition && getScrollElement && itemPosition.offsetTop) {
                        getScrollElement.scrollTop = itemPosition.offsetTop + 5;
                    }
                }
            }
        }
        if (!this.state.activityOnClicked) {
            this.state.activityOnClicked = true;
            this.setState({
                ...this.state,
                activityOnClicked: true
            });
        }
        setTimeout(() => {
            this.setState(() => ({
                ...this.state,
                activityOnClicked: false
            }));
        }, 1000);
        scrollListenner!.addEventListener("scroll", this.trackScrolling);
    };

    public componentWillMount = () => {
        if (this.props.courseContentWeekActivities && this.props.courseContentWeekActivities.length > 4 && this.props.actId) {
            const getFindElement = this.props.courseContentWeekActivities.find(x => x.activityId === this.props.actId);
            if (getFindElement) {
                const getWeekActivityIndex = this.props.courseContentWeekActivities.indexOf(getFindElement);
                this.state.showMoreCount = getWeekActivityIndex + 5;
            }
        }
    };

    public componentWillReceiveProps = (nextProps: ICourseContentWeekActivities, prevProps: ICourseContentWeekActivities) => {
        if (nextProps.actId && nextProps.actId !== this.props.actId) {
            this.activityOnClickProcessing(nextProps);
        }
    };

    public getActivityId = (activityId: string | null | undefined): string => {
        if (activityId) {
            return activityId;
        } else {
            if (this.props.courseContentWeekActivities) {
                if (this.props.courseContentWeekActivities && this.props.courseContentWeekActivities.length > 0) {
                    return this.props.courseContentWeekActivities![0].activityId!;
                }
            }
        }
        return '';
    };

    public addAndRemoveActiveClass = (item: ICourseContentWeekActivities) => {
        let getActivityMenuItemElement = document.getElementById('week_activity_' + item.actId);
        if (!getActivityMenuItemElement) {
            if (this.props.courseContentWeekActivities && this.props.courseContentWeekActivities.length > 0) {
                getActivityMenuItemElement = document.getElementById(
                    'week_activity_' + this.props.courseContentWeekActivities[0].activityId
                );
            }
        }
        const getAllActiveClass = document.getElementsByClassName('courseContentWeekActivityActive');
        for (let index = 0; index < getAllActiveClass.length; index++) {
            getAllActiveClass[index].classList.remove('courseContentWeekActivityActive');
        }
        if (getActivityMenuItemElement) {
            getActivityMenuItemElement.classList.add('courseContentWeekActivityActive');
        }

        setTimeout(() => {
            let itemPostisiton;
            if (item.actId) {
                itemPostisiton = document.getElementById('week_activity_' + item.actId);
            } else {
                itemPostisiton = document.getElementById('header' + item.weekOrUnitId);
            }
            const getScrollElement = document.getElementById('profileMainLoading_Content');
            if (itemPostisiton && getScrollElement && itemPostisiton.offsetTop) {
                getScrollElement.scrollTop = itemPostisiton.offsetTop - 5;
            }
        }, 500);
    };

    public activityOnClickProcessing = (props: ICourseContentWeekActivities) => {
        let getActivitiesType: GetActivitiesType;
        let activityId = this.getActivityId(props.actId);
        if (props.courseContentMenuType === CourseContentMenuType.week || props.courseContentMenuType === CourseContentMenuType.weekAndActivityStory) {
            getActivitiesType = GetActivitiesType.Week;
        } else if (props.courseContentMenuType === CourseContentMenuType.weekAndActivity) {
            getActivitiesType = GetActivitiesType.Activity;
        } else {
            getActivitiesType = GetActivitiesType.Course;
        }
        if (!props.courseContentWeekActivities!.some(x => x.activityId === props.actId)) {
            activityId =
                props.courseContentWeekActivities &&
                    props.courseContentWeekActivities.length > 0 &&
                    props.courseContentWeekActivities[0].activityId
                    ? props.courseContentWeekActivities[0].activityId
                    : '';
        }
        if (props.courseContentMenuType === CourseContentMenuType.weekAndActivityStory) {
            this.setState({
                ...this.state,
                enableScroll: false,
                selectedActivityId: props.actId
            });
        }
    };

    public showMoreOnClick = (event: React.MouseEvent<HTMLDivElement>) => {
        this.setState({
            ...this.state,
            showMoreCount: this.state.showMoreCount + 5
        });

        this.props.dispatch(Actions.SetGetMoreActivities(true))
    };

    renderActivityDatas = (activity: any, isMoreActivity: boolean, imgComponent: any, labelString: string ) => {
        let activityEnrollment = this.props.enrollmentData?.find(en => en.activityId === activity.activityId);
        let isActivityCompleted = this.props.userType === UserType.Student && (activityEnrollment?.status === 2);

        let divStyle = {};
        if(isMoreActivity){
            divStyle = (activity.beginDate && activity.beginDate > Moment().format('yyyy-MM-DDTHH:mm:ss')) ? { opacity: 0.5 } : {}
        }else{
            divStyle = (activity.beginDate && (activity.beginDate > Moment().format('yyyy-MM-DDTHH:mm:ss'))) || activity.activeStatus === 0
            ? { opacity: 0.5 } : {}
        }

        return(
                <div
                    key={activity.activityId}
                    id={'week_activity_' + activity.activityId}
                    data-weekid={activity.termWeekId}
                    data-activityid={activity.activityId}
                    className={'media  ' + activity.activityType!.toLowerCase()}
                    onClick={this.activityOnClick}
                    aria-hidden="true"
                    style={divStyle}
                >
                    {
                        (isActivityCompleted) ?
                            (
                                <div className="circle" style={{ width: 24, height: 24 }}>
                                    <i className="material-icons" style={{ fontSize: 16, fontWeight: 'bold' }}>done</i>
                                </div>
                            )
                            : (activity.activityType && imgComponent)
                    }
                    <div className="modal-body d-flex justify-content-between">
                        <label tabIndex={0}  onKeyDown={(event:any) => {
                        if (event.key === 'Enter') {
                            this.activityOnClick(event)
                        }
                    }}>{labelString}</label>
                        <div id='movementOptions' className="movement_options d-none">
                            <a href="#"><img src={_common.GetDefaultIcons('movement')} alt="" /></a>
                            <a href="#"><img src={_common.GetDefaultIcons('chevronup')} alt="" /></a>
                            <a href="#"><img src={_common.GetDefaultIcons('chevrondown')} alt="" /></a>
                        </div>
                    </div>
                </div>
        )
    }

    returnImageContent = (activity: any, isMoreActivity: boolean) => {
        return(
            isMoreActivity ?
            <img
            className="mr-1"
            style={{ width: '16px', marginLeft: '.25rem', filter: 'grayscale(1)' }}
            src={_common.GetActivityTypeIcons(activity.activityType)}
            alt="Link Icon"
            />
            :
            <img
                className="mx-2"
                style={{ width: '16px', height: 'auto', filter: 'grayscale(1)' }}
                src={_common.GetActivityTypeIcons(activity.activityType)}
                alt=" Activity Icon"
            />
        )
    }

    renderCourseContentWeekActivities = () => {
        let content;
        let label = "";
        let isMoreActivity = this.props.courseContentWeekActivities!.length > this.state.showMoreStartedCount;

        if(isMoreActivity){
            content =   <React.Fragment>
                            {this.props.courseContentWeekActivities!.slice(0, this.state.showMoreCount + 1).map(activity => (
                                this.renderActivityDatas(activity, isMoreActivity, this.returnImageContent(activity, isMoreActivity),activity.name ?? T.t('r_activity_name_cannot_reached'))
                            ))}
                            {(this.props.courseContentWeekActivities!.length - (this.state.showMoreCount + 1) > 0) && (
                                <div className="media week_activity_show_more" onClick={this.showMoreOnClick}>
                                    <div className="modal-body">
                                        <label>{T.t('r_gen_show_more')}</label>
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
        }
        else{
            content = this.props.courseContentWeekActivities!.map(activity => (
                this.renderActivityDatas(activity, isMoreActivity, this.returnImageContent(activity, isMoreActivity),activity.name && activity.name.length > 32 ? activity.name.slice(0, 32).toString() + ' ...' : (activity.name ?? T.t('r_activity_name_cannot_reached')) )
            ))
        }
        return content;
    }

    public render() {
        let getActivityMenuItemElement = document.getElementById('collapse' + this.props.showMenuById);

        return (
            <React.Fragment>
                {this.props.courseContentWeekActivities && this.props.courseContentWeekActivities.length > 0 ? (
                    this.renderCourseContentWeekActivities()
                ) : (
                    <div className="media">
                        <div className="modal-body">
                            <label>{T.t('r_no_activities_found')}</label>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ICourseContentWeekActivities): ICourseContentWeekActivities => {
    if (!state) {
        return ownProps;
    }
    const newProps: ICourseContentWeekActivities = Object.assign({}, ownProps, {
        courseContentWeekActivities: state.coursePage.courseContentWeekActivities,
        courseContentWeekActivitiesLoading: state.coursePage.courseContentWeekActivitiesLoading,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        actId: state.coursePage.actId,
        courseContentMenuType: state.coursePage.courseContentMenuType,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        enrollmentData: state.enrollment.enrollmentData,
        userType: state.login.identitiy.userType,
        courseContentActivityCardRefresh: state.coursePage.courseContentActivityCardRefresh,
        activityCard: state.coursePage.activityCard,
        activityFilters: state.coursePage.activityFilters,
        resetShowMoreCount: state.coursePage.resetShowMoreCount
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.coursePage.actId === prev.coursePage.actId &&
        next.coursePage.weekOrUnitId === prev.coursePage.weekOrUnitId &&
        next.coursePage.courseContentActivityCardRefresh === prev.coursePage.courseContentActivityCardRefresh &&
        next.coursePage.activityCard === prev.coursePage.activityCard &&
        next.coursePage.activityFilters === prev.coursePage.activityFilters &&
        next.coursePage.resetShowMoreCount === prev.coursePage.resetShowMoreCount;
    return ret;
};

const CCourseContentWeeksActivities = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CourseContentWeeksActivities);

export default CCourseContentWeeksActivities;
